export enum CASH_ADVANCE_STATUS {
	Requested = 1,
	OnApproval = 2,
	Approved = 3,
	Returned = 4,
	Rejected = 5,
	Submitted = 6,
	PartialLegalized = 7,
	Legalized = 8,
}

export enum CASH_ADVANCE_TYPE {
	Advance = 1,
	PettyCash = 2,
	PurchaseOrder = 3
}

export const CASH_ADVANCE_TABS_IDS = {
	'requested': [CASH_ADVANCE_STATUS.Requested, CASH_ADVANCE_STATUS.OnApproval, CASH_ADVANCE_STATUS.Returned],
	'approved': [CASH_ADVANCE_STATUS.Approved],
	'approved_po': [CASH_ADVANCE_STATUS.Approved],
	'submitted': [CASH_ADVANCE_STATUS.Submitted],
	'partial-legalized': [CASH_ADVANCE_STATUS.PartialLegalized],
	'legalized': [CASH_ADVANCE_STATUS.Legalized],
	'rejected': [CASH_ADVANCE_STATUS.Rejected],
}

export enum INVOICE_STATUS {
	New = 1,
	Submitted = 2,
	Legalized = 3,
	Rejected = 4,
	Approved = 5,
	ReviewedFinances = 6,
	ReverseInvoice = 0
}

export enum INVOICE_TYPES {
	Invoice = 1,
	BankExpenses = 2,
	Deposit = 3,
	CreditNote = 4,
	Refund = 5
}
